import {
  MDBAutocomplete,
  MDBBtn,
  MDBIcon,
  MDBModalHeader,
} from "mdb-react-ui-kit";
import React, { memo, useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { getHuntsgroups } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
export default memo(({ data, isConnectable, id }) => {
  const [acdgroups, setAcdgroups] = useState([]);
  console.log(data.hdata);
  const [rNode, setDNode] = useState(data.hdata ? data.hdata.nid : -1);

  function onDelete(id) {
    data.onDelete(id);
  }
  async function fetchACDGroupData() {
    let data = [];
    try {
      const response = await getHuntsgroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      const rawData = await response.json();
      if (response.status === 200) {
        data = rawData?.groups ?? [];
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
    }
    setAcdgroups([{ _id: -1, title: "Create new ACD Group" }, ...data]);
  }

  useEffect(() => {
    fetchACDGroupData();
  }, []);
  function onDelete(id) {
    data.onDelete(id);
  }

  const [customData, setCustomData] = useState(acdgroups);
  const onCustomSearch = (value) =>
    setCustomData(
      acdgroups.filter((item) =>
        item.title.toLowerCase().startsWith(value.toLowerCase())
      )
    );
  const openLocation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem("selectedItem", data.hdata.selected);
    window.open("/acdgroup");
  };

  const autoFocus = (event) => {
    if (event.target.value != "") {
      event.target.select();
      setCustomData(acdgroups);
    }
  };
  const deleteHandle = (h, hs) => {
    data.actionExecutor({ action: 2, value: { h }, handles: hs });
  };

  useEffect(() => {
    data.handles = [{ name: "No agents logged in" }, { name: "Max callers exceeded" }, { name: "Wait timeout" }];
    data.actionExecutor({ action: 0 });
  }, [acdgroups]);

  return (
    <>
      <CFNodeUI
        headerClass="darkBlueNodeHeader"
        data={data}
        targethandles={data.handles}
        deletable={true}
        onDelete={onDelete}
        onHandleDelete={deleteHandle}
        bodyContnent={
          <>
            <div className="nodeSelectLinkIcon">
              <MDBAutocomplete
                data={customData}
                displayValue={(row) => row.title}
                placeholder={"Choose ACD Group"}
                value={data.selected_object ? data.selected_object.title : null}
                onClick={autoFocus}
                onSelect={(e) =>
                  (function processClick(value) {
                    if (value === "Create new ACD Group") {
                      data.actionExecutor({ action: 1 });
                    } else {
                      let tGrp = acdgroups.filter(
                        (grp) => grp.title === value
                      )[0];
                      data.selected_object = tGrp;
                      data.actionExecutor({
                        action: 2,
                        value: tGrp || -1,
                      });
                    }
                  })(e)
                }
                onSearch={onCustomSearch}
                itemContent={(result) => {
                  return (
                    <>
                      <div className="autocomplete-custom-item-content">
                        <div className="autocomplete-custom-item-title">
                          {result.title}
                        </div>
                      </div>
                    </>
                  );
                }}
              />

              {data.selected_object &&
                data.selected_object.label !== "Create new ACD Group" && (
                  <>
                    <MDBIcon
                      fas
                      icon="external-link-square-alt"
                      className="nodeLinkIcon"
                      onClick={(e) => openLocation(e)}
                    />
                  </>
                )}
            </div>
          </>
        }
        targetNode={true}
      />
    </>
  );
});
